import { useState, useEffect } from 'react';
import { useAuthenticated  } from 'react-admin';
import {refreshTokenGen} from '../../../inMemoryJwt.js'
import { array } from 'yup';


function HeaderSubMenuPage(props) {
    useAuthenticated();
    
    useEffect(() => {
        let urlLocation = window.location.href;
        urlLocation = urlLocation.split('/');
        urlLocation = urlLocation[urlLocation.length - 2];
    
        const tokenExpires = localStorage.getItem('tokenexpires');
        let refreshTOk = localStorage.getItem('refresh_token');
        // if(parseInt(tokenExpires) < new Date().getTime()){
        //     refreshTokenGen(refreshTOk).then(challenge => {
        //         if(challenge){
        //             getPosts(urlLocation);
        //         }
        // })
        // } else {
        //     getPosts(urlLocation);
        // }
    }, []);
    const youElements = (e, activateId, prodId) => {
        console.log('youElements', activateId, prodId);
        localStorage.setItem('projectId', prodId);
        if(props.checkDocumentDirtyState){
            props.checkDocumentDirtyState();
        } else {
            window.location.href = `/parts-and-service/${activateId}/vos-elements`;
        }
    }
    const gotoPersonnalisationPage = (e, activateId, prodId) => {
        localStorage.setItem('projectId', prodId);
        window.location.href = `/parts-and-service/${activateId}/personnalisation`;
    }

    const isValidId = (id) => {
        return id !== undefined && id !== null && id !== '' && id !== 'undefined';
    };
    
    
    return (
        <>
          <ul className='resetList psTabBtn'>
                <li><a href={`/parts-and-service/${props.edtionId}/instructions`} className="redBtn">Mode d’emploi</a></li>
                <li><a onClick={(e) => gotoPersonnalisationPage(e, props.edtionId, props.proId)} className={`${!isValidId(props.proId) ? "redBtn" : "disbaleBtn redBtn"}`}>Personnalisation</a></li>
                <li><a onClick={(e) => youElements(e, props.edtionId, props.proId)} className={`${isValidId(props.proId) ? "redBtn" : "disbaleBtn redBtn"}`} >Commande</a></li>
            </ul>
        </>
    );
  }
export default HeaderSubMenuPage;